import { useEffect, useState } from 'react';

export default function useScript(src) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener('load', () => setLoaded(true));
    document.body.append(script);

    return () => {
      script.remove();
    };
  }, [src]);

  return loaded;
}
